import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Text } from '@/Components/Preferences/PreferencesComponents/Content';
const SharingStatusText = ({ subscriptionState }) => {
    const { usedInvitationsCount, allowedInvitationsCount } = subscriptionState;
    return (_jsxs(Text, { className: "mt-1", children: ["You've used ", _jsx("span", { className: "font-bold", children: usedInvitationsCount }), " out of ", allowedInvitationsCount, ' ', "subscription invites."] }));
};
export default observer(SharingStatusText);
